// extracted by mini-css-extract-plugin
export default {"wrapper":"Ho","form":"Io","circle":"Jo","success":"Ko","button":"Lo"};